export default __webpack_public_path__ + "static/media/brazowa.9a41a148.png";